<template>
  <div>
    <a-form-model class="ec-register-form switch-form" :model="form" :rules="rules" ref="registerForm" hideRequiredMark :colon="false" labelAlign="left"  :key="1">
      <!-- 邮箱找回 -->
      <template v-if="comp === 'backEmail'">
        <a-form-model-item prop="email" :label="$t('common_form_email')" htmlFor="email" :key="comp + 'email'">
          <a-input v-model="form.email" autoComplete="off" v-forlogin="'email'"></a-input>
        </a-form-model-item>
        <!-- 邮箱验证码 -->
        <a-form-model-item prop="messageCode" :label="$t('common_form_email_code')" htmlFor="messageCode" :key="comp + 'messageCode'">
          <a-input :maxLength="6" autoComplete="off" v-model="form.messageCode" v-forlogin="'messageCode'">
            <a-spin slot="suffix" :spinning="isCodeLoading && !timing">
              <a-button v-show="!timing" id="captcha-button" type="link">{{$t('common_btn_send_ver')}}</a-button>
              <span v-show="timing">{{timing}} s</span>
            </a-spin>
          </a-input>
        </a-form-model-item>
      </template>
      <!-- 手机找回 -->
      <template v-else>
        <!-- 手机号 -->
        <a-form-model-item prop="phone" :label="$t('common_form_phone')" htmlFor="phone" class="input-addon-before-form-item" :key="comp + 'phone'">
          <a-input
            autoComplete="off"
            v-model="form.phone"
            :maxLength="11"
            @keyup="form.phone = form.phone.replace(/[^\d]/g, '')"
            v-forlogin="'phone'"
          >
            <a-select :value="form.phoneCode | disCountryCode" :dropdownMatchSelectWidth="false" slot="addonBefore" :getPopupContainer="() => $refs['registerForm'].$el" >
              <div slot="dropdownRender" style="overflow: auto; padding: 4px 0" :style="{minWidth: currentLang === 'zh_CN' ? '260px' : '400px'}">
                <RecycleScroller
                  style="max-height: 400px; min-height: 32px; overflow:auto"
                  :items="countryCodeList"
                  :item-size="32"
                  :buffer="100"
                  :prop="{value: 'index', text: 'name' + currentLangList[currentLang]}"
                  @selected="changeInternational"
                >
                  <template v-slot="{item}">
                    <div style="display:flex;justify-content:space-between; width:100%">
                      <span style="width: calc(100% - 70px);white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item['name' + currentLangList[currentLang === 'ko_KR' ? 'en_US' : currentLang]]}}</span>
                      <span style="margin-right:2px">+ {{item.phonecode}}</span>
                    </div>
                  </template>
                </RecycleScroller>
              </div>
            </a-select>
          </a-input>
        </a-form-model-item>
        <!-- 右侧验证码 -->
        <a-form-model-item prop="imgCode" :label="$t('common_form_identifying_code')" htmlFor="imgCode" :key="comp + 'imgCode'">
          <a-input autoComplete="off" v-model="form.imgCode" :maxLength="4" v-forlogin="'imgCode'">
            <span slot="suffix" style="width:56px;height:33px;background:rgb(253, 253, 253);">
              <a-spin v-if="imgCodeLoading" size="small" style="margin-left: 25px; margin-top: 9px;" />
              <img v-else :src="imgCodeData" style="cursor:pointer; width: 100%; height: 100%" @click="getImgCode" />
            </span>
          </a-input>
        </a-form-model-item>
        <!-- 短信验证码 -->
        <a-form-model-item prop="messageCode" :label="$t('common_form_sms_code')" htmlFor="messageCode"  :key="comp + 'messageCode'">
          <a-input :maxLength="6" autoComplete="off" v-model="form.messageCode" v-forlogin="'messageCode'">
            <a-spin slot="suffix" :spinning="isCodeLoading && !timing">
              <a-button v-show="!timing" id="captcha-button" type="link">{{$t('common_btn_send_ver')}}</a-button>
              <span v-show="timing">{{timing}} s</span>
            </a-spin>
          </a-input>
        </a-form-model-item>
      </template>
       <!-- 设置密码 -->
      <a-form-model-item prop="password" :label="$t('common_form_设置密码')" htmlFor="password">
        <a-input-password autoComplete="new-password" v-model="form.password" v-forlogin="'password'" />
      </a-form-model-item>
      <!-- 再次输入密码 -->
      <a-form-model-item prop="password2" :label="$t('common_form_再次输入密码')" htmlFor="password2">
        <a-input-password autoComplete="new-password" v-model="form.password2" v-forlogin="'password2'" />
      </a-form-model-item>
    </a-form-model>
    <a class="ec-register-submit" :class="{'ec-register-submit__loading': submitLoading}">
      <a-spin v-if="submitLoading">
        <a-icon slot="indicator" type="loading" style="font-size: 24px;  color: #fff" spin />
      </a-spin>
      <span style="flex: 1; text-align:center" v-else  @click="onSubmit" >{{ $t('common_btn_confirm') }}</span>
    </a>
    <a class="ec-register-submit" style="background: #fff; color: #007BFC; font-size: 14px; margin-top: 10px" @click="$emit('to', 'login')">
      {{ $t('common_login_return_login') }}
    </a>

    <!-- 验证码容器 -->
    <div id="captcha-element"></div>
  </div>
</template>

<script>
import md5 from 'md5'
import RecycleScroller from '@/components/VirtualScroll/RecycleScroller'
import { mapState } from 'vuex'
import { debounce } from '@/utils/util'
import {
  LoginCodeAvatar, // 图形验证码
  PhoneCodeInterface // 区号
} from '@/api/sso/code'
import mixins from '../mixins'
import { SSO_SYS_USER_SAIL } from '@/store/mutation-types'

import {
  retrievePassByPhone,
  retrievePassByEmail, // 邮箱找回提交
  sendRetrievePassEmail, // 发送验证码
  sendRetrievePassCore
} from '@/api/sso/user'

export default {
  mixins: [mixins],
  components: {
    RecycleScroller
  },
  props: {
    comp: String
  },
  data () {
    const validatePhone = (rule, value, callback) => {
      if (value.length < 7 || value.length > 12 || !/^[\d]+$/.test(value)) {
        callback(new Error(this.$t('common_form_please_enter', [this.$t('common_form_正确的手机号码')])))
      } else {
        callback()
      }
    }

    const validatePassWord2 = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error(this.$t('common_form_password2')))
      } else {
        callback()
      }
    }
    return {
       countryCodeList: [
        { name_zh: '中国大陆', name: 'CHINA', phonecode: '86' },
        { name_zh: '中国香港', name: 'HONG KONG', phonecode: '852' },
        { name_zh: '中国澳门', name: 'MACAO', phonecode: '853' },
        { name_zh: '中国台湾', name: 'TAIWAN', phonecode: '886' },
        { name_zh: '美国', name: 'UNITED STATES', phonecode: '1' },
        { name_zh: '澳大利亚', name: 'AUSTRALIA', phonecode: '61' },
        { name_zh: '英国', name: 'UNITED KINGDOM', phonecode: '44' }
      ],
      currentLangList: {
        'en_US': '',
        'zh_CN': '_zh'
      },
      form: {
        phoneCode: '86',
        phone: ''
      },
      rules: {
        phone: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_phone')]), trigger: [] },
          { validator: validatePhone, trigger: ['blur'] }
        ],
        imgCode: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_identifying_code')]), trigger: [] },
          { length: 4, message: this.$t('common_form_please_enter', [this.$t('common_form_four-digit')]), trigger: [] }
        ],
        email: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_email')]), trigger: [] },
          { pattern: /^[._-\w\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: this.$t('common_form_格式错误', [this.$t('common_form_email')]), trigger: [] }
        ],
        messageCode: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_vr_code')]), trigger: [] },
        password: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_login_pd2')]), trigger: [] },
          // { pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,16}$/, message: this.$t('common_form_密码格式错误'), trigger: [] }
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,16}$/, message: this.$t('common_form_密码格式错误'), trigger: [] }
        ],
        password2: { validator: validatePassWord2, trigger: [] }
      },
      imgCodeLoading: false,
      imgCode: '',
      // imgCodeKey: '',
      imgCodeData: '',
      timer: null,
      timing: 0,
      isCodeLoading: false,
      submitLoading: false
    }
  },
  filters: {
    disCountryCode (val) {
      return `+ ${val}`
    }
  },
  computed: {
    ...mapState({
      currentLang: state => state.app.lang
    })
  },
  watch: {
    comp () {
      this.timing = 0
      this.$set(this.form, 'messageCode', '')
      clearTimeout(this.timer)
      this.$refs['registerForm'].clearValidate()
      this.initCaptcha()
    }
  },
  methods: {
    // 选择区号
    changeInternational (val) {
      this.form.phoneCode = val.phonecode
    },
    onSubmit () {
      this.$refs['registerForm'].validate((flag, errors) => {
        if (!flag) return this.$message.error(errors[Object.keys(errors).sort((a, b) => a - b)[0]][0].message)
        this.submitLoading = true
        const {
          email,
          messageCode,
          password,
          phoneCode,
          phone
        } = this.form
        let api = retrievePassByPhone
        let params = {
          phone,
          shortMessageCode: messageCode,
          phoneCode
        }
        let commonParams = {
          password,
          systemCode: 'SSO_SYS_USER'
        }
        if (this.comp === 'backEmail') {
          api = retrievePassByEmail
          params = {
            email,
            emailCode: messageCode
          }
        }
        api({ ...commonParams, ...params }).then(() => {
           this.$info({
            icon: () => (<icon-font type="gb-icon-Info"></icon-font>),
            title: this.$t('common_login_找回密码成功'),
            content: this.$t('所有已登录当前账号的设备将自动退出登录，请在登录页面重新登录。'),
            okText: this.$t('common_login_return_login'),
            onOk: () => {
              this.$emit('to', 'login')
              this.submitLoading = false
            }
          })
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    getImgCode () {
      this.imgCodeLoading = true
      debounce(() => {
        LoginCodeAvatar().then(({ data }) => {
          this.form.imgCodeKey = data.imgCodeKey
          this.imgCodeData = data.imgCodeData
        })
          .finally(() => {
            this.imgCodeLoading = false
          })
      }, 500)
    },
    getShortMessageCode (captchaVerifyParam) {
      const { email, phoneCode, phone, imgCode, imgCodeKey } = this.form
      let api = sendRetrievePassEmail
      let params = {
        captchaVerifyParam,
        email,
        emailTextCode: 'SSO_RETRIEVE_PASSE_MAIL'
      }
      let validateFields = ['email']
      if (this.comp === 'backPhone') {
        const timestamp = Date.now()
        const sign = md5(timestamp + phone + SSO_SYS_USER_SAIL)
        api = sendRetrievePassCore
        params = { captchaVerifyParam, phoneCode, phone, imgCode, imgCodeKey, sign, timestamp }
        validateFields = ['phone', 'imgCode']
      }
      let error = false
      this.$refs['registerForm'].validateField(validateFields, message => {
        if (message) {
          error = 1
          this.$message.warning(message)
        }
      })

      if (error) return

      this.isCodeLoading = true
      api({ ...params })
        .then(() => {
          this.timing = 60
          this.countdown()
        })
        .catch(() => {
          this.getImgCode()
        })
        .finally(() => {
          this.isCodeLoading = false
        })
    },
    countdown () {
      const { timing } = this
      clearTimeout(this.timer)
      if (timing > 0) {
        this.timer = setTimeout(() => {
          this.timing = timing - 1
          this.countdown()
        }, 1000)
      }
    },
    initCaptcha () {
      if (!window.initAliyunCaptcha) {
        this.$message.warning('阿里云验证码JS未加载')
        return
      }

      this.$nextTick(() => {
        window.initAliyunCaptcha({
          SceneId: 'qbz2hcw3',
          mode: 'popup',
          element: '#captcha-element',
          button: '#captcha-button',
          // 验证成功回调
          success: (captchaVerifyParam) => {
            this.getShortMessageCode(captchaVerifyParam)
          },
          // 验证失败回调
          fail: (error) => {
            console.log('验证码验证失败:', error)
          },
          slideStyle: {
            width: 360,
            height: 40
          },
          language: 'cn'
        })
      })
    }
  },
  mounted () {
    this.getImgCode()
    this.initCaptcha()
    PhoneCodeInterface({}).then(({ data }) => { // 区号
      this.countryCodeList = JSON.parse(data.result).map((item, index) => ({ ...item, index }))
    }).finally(() => {
      this.form.phoneCode = this.countryCodeList[0].phonecode
    })
  }
}
</script>

<style lang="less" scoped>
@color: #077BFC;
/deep/.@{ant-prefix}-select-selection {
  .@{ant-prefix}-select-selection__rendered {
    margin: 0 30px 0 0;
  }
}
.ec-register {
  &-form {
    input {
      width: 100%;
    }
  }
  &-agreement {
    margin-top: 20px;
    .@{ant-prefix}-btn-link {
      margin: 0;
      padding: 0;
      height: auto;
      line-height: unset;
    }
  }
  &-submit {
    width: 100%;
    height: 55px;
    line-height: 55px;
    background: @color;
    color: #fff;
    display: flex;
    font-size: 18px;
    border-radius: 2px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin: 30px auto 0 auto;
    transition: all 0.5s;
    &__disable {
      background: #ddd;
      cursor: default;
    }
    &__loading {
      width: 55px;
      border-radius: 55px;
      background: fade(@color, 75%);
    }
  }
}
</style>
